import SelectorEngine from '../../utils/dom/selector-engine';

class TermsConditions {
	constructor() {
		this.container = undefined;

		this.initiateTermsConditions();
	}

	initiateTermsConditions() {
		this.container = SelectorEngine.findOne('.p-terms-conditions');

		if (this.container !== null) {
			const closeCta = SelectorEngine.findOne('.js-dismiss-terms-error', this.container);
			closeCta.addEventListener('click', () => {
				const errorContainer = SelectorEngine.findOne('.p-terms-conditions__alert', this.container);
				errorContainer.classList.add('u-hidden');
			});
		}
	}
}

const globalTermsConditions = new TermsConditions;

export default globalTermsConditions;
